import './App.css';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import ReadingExperience from './components/ReadingExperience';
import BetaTesterForm from './components/BetaTesterForm';
import Quote from './components/Quote';
import Companion from './components/Companion';
import Footer from './components/Footer';
import { Analytics } from "@vercel/analytics/react"
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AboutUs from './components/AboutUs';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';

function Home() {
  return (
    <div className="App">
      <Navigation />
      <HeroSection />
      <ReadingExperience />
      <BetaTesterForm />
      <Quote />
      <Companion />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Analytics />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/privacy' element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
